export const FILTER_FIELDS = {
  DATE_RANGE: "date_range",
  DATE_RANGE_SELECT: "date_range_select",
  TEXT: "text",
  SELECT: "select",
  SELECT_BUTTON: "select_button",
  CHAIN_POS: "chain_pos",
  STATE_CITY: "state_city",
  AUTOCOMPLETE: "autocomplete"
}

export const CHART_TYPES = {
  LINE: "line",
  BAR: "bar",
  AREA: "area",
  DONUT: "donut",
  PIE: "pie",
  KPI: "kpi",
  TREEMAP: "treemap",
  TABLE: "table",
  COMBO: "combo",
  MAP: "map",
  STACKED_BAR: "stacked-bar"
}

export const CHART_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  FULL: "full"
}

export const FILTER_FIELD_TYPES = {
  DATE_RANGE: "date_range",
  SELECT: "select",
  TEXT: "text"
}

export const DEFAULT_CHART_COLORS = [
  "#0937D6",
  "#F44336",
  "#FF9800",
  "#8BC34A",
  "#9C27B0",
  "#00BCD4",
  "#FF5722",
  "#607D8B"
]

export const DEFAULT_APEX_OPTIONS = {
  chart: {
    toolbar: {
      show: false
    },
    zoom: {
      enabled: false
    },
    fontFamily: "Open Sans, sans-serif"
  },
  tooltip: {
    enabled: true
  },
  dataLabels: {
    enabled: false
  },
  legend: {
    position: "bottom",
    horizontalAlign: "center"
  },
  grid: {
    borderColor: "#f1f1f1"
  }
}
